import React, { FC } from 'react';
import classNames from 'classnames';

import { UsedCurrentCheckItemButtons } from 'Src/feature/check-item/useCurrentCheckItemButtons';
import { useMenuControl } from 'Src/feature/menu/useMenuControl';

import { MenuItemButtons } from './MenuItemButtons';
import { MenuItemGroupButtons } from './MenuItemGroupButtons';
import { MenuItemOpenPriceModal } from './MenuItemOpenPriceModal';

import styles from './Menu.module.scss';

interface MenuProps {
  className?: string;
  checkItemButtons: UsedCurrentCheckItemButtons;
}

/**
 * component wrapper for menu views
 */
const Menu: FC<MenuProps> = ({ className, checkItemButtons }) => {
  const control = useMenuControl({ checkItemButtons });
  return (
    <>
      <div
        className={classNames(styles.root, className, {
          [styles.show_menu_group_buttons]: control.showMenuGroupButtons,
        })}
      >
        <MenuItemGroupButtons control={control} />
        {control.currentCheck.query.data && <MenuItemButtons control={control} />}
      </div>
      <MenuItemOpenPriceModal
        open={control.modal.openPrice.isOpen}
        button={control.selectedButton}
        onClose={control.modal.openPrice.close}
        onDone={control.modal.openPrice.onDone}
      />
    </>
  );
};

export default Menu;
